import React from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const PaginationMed = ({ currentPage, totalPages, goToPage }) => {
  return (
    <div className="h-[49px] w-full border rounded-md flex justify-end items-center p-5">
      <div className="flex items-center justify-center space-x-2">
        <button
          className={`p-2 rounded-md ${
            currentPage === 1
              ? "text-gray-400 cursor-not-allowed bg-white"
              : "text-gray-700 bg-white"
          }`}
          onClick={() => goToPage("",currentPage - 1)}
          disabled={currentPage === 1}
        >
          <FaChevronLeft className="text-[#189FAA]" />
        </button>

        {[...Array(totalPages)].map((_, index) => {
          const page = index + 1;
          return (
            <button
              key={page}
              className={`px-3 py-1 rounded-md ${
                currentPage === page
                  ? "bg-teal-500 text-white text-sm"
                  : "text-gray-700 text-sm hover:bg-gray-200 bg-white border rounded-md"
              }`}
              onClick={() => goToPage("", page)}
            >
              {page}
            </button>
          );
        })}

        <button
          className={`p-2 rounded-md ${
            currentPage === totalPages
              ? "text-gray-400 cursor-not-allowed bg-white"
              : "text-gray-700 bg-white"
          }`}
          onClick={() => goToPage("",currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          <FaChevronRight className="text-[#189FAA]" />
        </button>
      </div>
    </div>
  );
};

export default PaginationMed;
